import { axios } from 'libs';

const resource = '/configuracoes-ouvidoria';

export const findByEntidadeLogada = () => axios.get(resource);

export const save = configuracao => axios.put(resource, configuracao);
